import { Font } from '@react-pdf/renderer';
import interRegularBase64 from './inter-regular';
import interBoldBase64 from './inter-bold';

const toDataUri = (base64: string) => `data:font/ttf;base64,${base64}`;

let registered = false;

export const registerPdfFonts = () => {
  if (registered) return;
  registered = true;

  Font.register({
    family: 'Inter',
    fonts: [
      { src: toDataUri(interRegularBase64), fontWeight: 'normal' },
      { src: toDataUri(interBoldBase64), fontWeight: 'bold' },
    ],
  });

  // react-pdf domyślnie dzieli wyrazy dywizem, gdy nie mieszczą się w kolumnie — w nagłówkach
  // tabel dawało to „Customer Re-views" i „License & Complia-nce". Zwracamy wyraz nierozdzielony,
  // więc łamanie idzie po spacjach; za przepełnienie pojedynczym długim słowem odpowiada
  // `truncate` po stronie komponentu (tak było już robione dla adresów).
  Font.registerHyphenationCallback((word) => [word]);
};
